export default {"src":"/_next/static/image/src/images/our-food/peas.7321bc3512fe7437d22f625979bb76cf.svg","height":33,"width":70};